import {UyapRequest} from "./UyapRequest";
import app from "@/main";

export interface TahsilatReddiyatTalep {
    dosyaId: string | number,
    dosyaTurKod: number
}

export interface TahsilatReddiyatCevap {
    tahsilatList: Array<ITahsilatList>,
    reddiyatList: Array<IReddiyatList>,
    harcList: Array<IHarcList>,
    toplamTahsilat: number,
    toplamreddiyat: number,
    haricen: number,
    toplamTeminat: number,
    toplamTahsilHarci: number,
    toplamKalan: number,
    isIcraMi: boolean,
    message: string
}

export interface ITahsilatList {
    makbuzNo: string,
    dosyaNo: string,
    dosyaTurAciklama: string,
    birimAdi: string,
    odeyenKisi: string,
    tahsilatTuru: string,
    tahsilatTarihi: string,
    kalanMiktar: number,
    tahsilatTutari: number,
    kayitId: number
}

export interface IReddiyatList {
    makbuzNo: string,
    dosyaNo: string,
    dosyaTurAciklama: string,
    miktar: number,
    birimAdi: string,
    odeyenKisi: string,
    reddiyatNedeni: string,
    reddiyatTarihi: string,
    gelirVergisi: number,
    damgaVergisi: number,
    cezaeviHarcTutari: number,
    tahsilHarci: number,
    odenecekMiktar: number,
    kayitId: number
}

export interface IHarcList {
    makbuzNo: string,
    dosyaNo: string,
    dosyaTurAciklama: string,
    miktar: number,
    birimAdi: string,
    odeyenKisi: string,
    tahsilatTuru: string,
    tahsilatTarihi: string
}

export class TahsilatReddiyat extends UyapRequest<TahsilatReddiyatTalep, TahsilatReddiyatCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Tahsilat reddiyat sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "TahsilatReddiyat_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"tahsilatList":[{"makbuzNo":"0","dosyaNo":"2023/27440","dosyaTurAciklama":"İcra Dosyası","birimAdi":"Ankara 2. Genel İcra Dairesi","odeyenKisi":"ZAHİDE DEMİROK","tahsilatTuru":"Masraf Avansı Tahsilatı","tahsilatTarihi":"Feb 22, 2019 2:40:31 PM","kalanMiktar":8.5,"tahsilatTutari":14,"kayitId":105717417},{"makbuzNo":"0","dosyaNo":"2023/27440","dosyaTurAciklama":"İcra Dosyası","birimAdi":"Ankara 2. Genel İcra Dairesi","odeyenKisi":"ZAHİDE DEMİROK","tahsilatTuru":"Masraf Avansı Tahsilatı","tahsilatTarihi":"Feb 21, 2020 9:16:32 PM","kalanMiktar":5,"tahsilatTutari":5,"kayitId":123862400}],"reddiyatList":[{"makbuzNo":"0","dosyaNo":"2023/27440","dosyaTurAciklama":"İcra Dosyası","miktar":5.5,"birimAdi":"(Kapatılan)Ankara 26. İcra Dairesi","odeyenKisi":"PTT","reddiyatNedeni":"Posta Ücreti Reddiyatı","reddiyatTarihi":"Jul 20, 2020 10:18:06 AM","gelirVergisi":0,"damgaVergisi":0,"cezaeviHarcTutari":0,"tahsilHarci":0,"odenecekMiktar":5.5,"kayitId":105717417}],"harcList":[{"makbuzNo":"0","dosyaNo":"2023/27440","dosyaTurAciklama":"İcra Dosyası","miktar":37.2,"birimAdi":"Ankara 2. Genel İcra Dairesi","odeyenKisi":"ZAHİDE DEMİROK (ALACAKLI)","tahsilatTuru":"Peşin Harç","tahsilatTarihi":"Jun 29, 2016 3:27:40 PM"},{"makbuzNo":"0","dosyaNo":"2023/27440","dosyaTurAciklama":"İcra Dosyası","miktar":4.3,"birimAdi":"Ankara 2. Genel İcra Dairesi","odeyenKisi":"ZAHİDE DEMİROK (ALACAKLI)","tahsilatTuru":"Vekalet Suret Harcı","tahsilatTarihi":"Jun 29, 2016 3:27:40 PM"},{"makbuzNo":"0","dosyaNo":"2023/27440","dosyaTurAciklama":"İcra Dosyası","miktar":29.2,"birimAdi":"Ankara 2. Genel İcra Dairesi","odeyenKisi":"ZAHİDE DEMİROK (ALACAKLI)","tahsilatTuru":"Başvurma Harcı","tahsilatTarihi":"Jun 29, 2016 3:27:40 PM"},{"makbuzNo":"0","dosyaNo":"2023/27440","dosyaTurAciklama":"İcra Dosyası","miktar":4.3,"birimAdi":"Ankara 2. Genel İcra Dairesi","odeyenKisi":"Ahmet Münir YALÇINALP - Av. BURHAN YILDIZ (Borçlu Vekili)","tahsilatTuru":"Vekalet Suret Harcı","tahsilatTarihi":"Jul 15, 2016 9:31:08 AM"},{"makbuzNo":"0","dosyaNo":"2023/27440","dosyaTurAciklama":"İcra Dosyası","miktar":5.5,"birimAdi":"Ankara 2. Genel İcra Dairesi","odeyenKisi":"ZAHİDE DEMİROK","tahsilatTuru":"Posta Masrafı","tahsilatTarihi":"Jul 20, 2020 10:18:06 AM"}],"toplamTahsilat":19,"toplamreddiyat":5.5,"haricen":5.5,"toplamTeminat":0,"toplamTahsilHarci":75.0,"toplamKalan":13.5,"isIcraMi":true};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'dosya_tahsilat_reddiyat_bilgileri_brd.ajx';
    }

    async parse(data: TahsilatReddiyatCevap): Promise<TahsilatReddiyatCevap> {
        data.message = "Sorgulama başarılı"
        return data;
    }
}

export default TahsilatReddiyat;
